import { brushCursor, defaultCursor } from '../lib/cursor';

// Create blob URL for default cursor to reduce JS memory usage
const createDefaultCursorBlob = (cursor) => {
  const svgString = cursor;
  const blob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(blob);
};

const defaultCursorBlob = createDefaultCursorBlob(defaultCursor);
const defaultCursorURL = `url("${defaultCursorBlob}") 5 5, auto`;

const brushCursorBlob = createDefaultCursorBlob(brushCursor);
const brushCursorURL = `url("${brushCursorBlob}") 5 5, auto`;

export class CursorProvider {
  constructor() {
    this.cursor = '';
    this.el = null;
    this.cursors = {
      default: defaultCursorURL,
      brush: brushCursorURL,
    };
  }

  attach(stageContext) {
    const el = stageContext.canvas?.canvas;
    this.el = el;
  }

  set(cursor) {
    cursor = cursor || 'default';
    if (cursor === this.cursor) return;
    this.cursor = cursor;
    if (this.el) {
      const value = this.cursors[cursor] || cursor;
      this.el.style.cursor = value;
    }
  }

  setById(id) {
    switch (id) {
      case 'topLeft':
      case 'bottomRight':
        this.set('nwse-resize');
        break;
      case 'topRight':
      case 'bottomLeft':
        this.set('nesw-resize');
        break;
      case 'top':
      case 'bottom':
        this.set('ns-resize');
        break;
      case 'left':
      case 'right':
        this.set('ew-resize');
        break;
      case 'rotate':
        this.set('grab');
        break;
      case 'insert':
        this.set('crosshair');
        break;
      case 'copy':
        this.set('copy');
        break;
      case 'pointer':
        this.set('pointer');
        break;
      case 'brush':
        this.set('brush');
        break;
      default:
        this.set('');
    }
  }

  reset() {
    this.set('', 0);
  }

  detach() {
    this.reset();
    this.el = null;
  }

  dispose() {
    this.detach();
  }
}
